import React, { useEffect } from "react";
import useWorkerDetails from "./hooks/useWorkerDetails";
import { styled } from "@mui/system";
import { Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const StyledCard = styled(Card)({
  minWidth: "80%",
});

const WorkerDetailsFetcher = ({ formData, setFormData, errors, setErrors }) => {
  const { t, i18n } = useTranslation();
  const { workerFields, loading, error, wasFetched, empisActive } = useWorkerDetails(
    formData.workerId
  );
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      ...workerFields,
    }));
  }, [workerFields, setFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if(error){
      setErrors((prev) => ({
        ...prev,
        workerId: error
      }))
    } else{
      setErrors((prev) => ({
        ...prev,
        workerId: "",
        workerName: "",
        workerEmail: "",
        workerCountry: "",
      }))
    }
  }, [error, setErrors])

  return (
    <>
      <Grid item>
        <StyledCard>
          <CardContent>
            <Typography variant="subtitle1" gutterBottom color="textPrimary">
              {t("other.lblYourWorkerId")}
              <span style={{ color: "red" }}> *</span>
            </Typography>
            <TextField
              name="workerId"
              type="number"
              label={t("other.lblYourAnswer")}
              variant="standard"
              value={formData.workerId}
              onChange={handleChange}
              error={!!errors.workerId || (formData.workerId.length && formData.workerId.length < 6)}
              helperText={
                formData.workerId.length < 6
                  ? t("other.lblMinimumSixDigitsRequired")
                  : errors.workerId
              }
              style={{ width: "100%" }}
            />
            {loading && <p>Loading worker info...</p>}
          </CardContent>
        </StyledCard>
      </Grid>
      <Grid item>
        <StyledCard>
          <CardContent>
            <Typography variant="subtitle1" gutterBottom color="textPrimary">
              {t("other.lblYourDetails")}
            </Typography>
            <TextField
              sx={{ marginBottom: 2 }}
              name="workerName"
              type="workerName"
              label={t("pgHome.lblName")}
              variant="standard"
              value={formData.workerName}
              onChange={handleChange}
              style={{ width: "100%" }}
              disabled={wasFetched}
              error={!!errors.workerName}
              helperText={errors.workerName}
            />
            <TextField
              name="workerCountry"
              type="workerCountry"
              label={t("other.tlCountry")}
              variant="standard"
              value={formData.workerCountry}
              onChange={handleChange}
              style={{ width: "100%" }}
              disabled={wasFetched}
              error={!!errors.workerCountry}
              helperText={errors.workerCountry}
            />
          </CardContent>
        </StyledCard>
      </Grid>
    </>
  );
};

export default WorkerDetailsFetcher;
